import { DashboardLayout } from '@/components/layout/DashboardLayout';
import EllaKnowledgeConsole from '@/components/compliance/EllaKnowledgeConsole';
import { useTenantStore } from '@/hooks/useTenantStore';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export default function EllaKnowledge() {
  const { tenantId } = useTenantStore();

  const { data: company } = useQuery({
    queryKey: ['company', tenantId],
    queryFn: async () => {
      if (!tenantId) return null;
      const { data } = await supabase
        .from('companies')
        .select('jurisdiction')
        .eq('id', tenantId)
        .single();
      return data;
    },
    enabled: !!tenantId,
  });

  if (!tenantId) {
    return (
      <DashboardLayout>
        <div className="p-6 text-center text-muted-foreground">
          Please select a company to use Ella Knowledge
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Ella Knowledge Base</h1>
          <p className="text-muted-foreground mt-2">
            Research regulations and get detailed explanatory guidance on compliance matters.
          </p>
        </div>
        <EllaKnowledgeConsole jurisdiction={company?.jurisdiction} />
      </div>
    </DashboardLayout>
  );
}
